import React from "react";
import { ScreenShell, SelectableCard } from "../components";
import { T } from "../theme";
import { ACTIVITY_OPTIONS } from "../calc";
import type { ActivityKey } from "../types";

type Props = {
  step: number;
  total: number;
  value: ActivityKey;
  onChange: (key: ActivityKey, factor: number) => void;
  onNext: () => void;
  onBack: () => void;
  isMobile: boolean;
};

export function ActivityScreen({ step, total, value, onChange, onNext, onBack, isMobile }: Props): React.ReactElement {
  return (
    <ScreenShell
      step={step}
      total={total}
      title="How active are you?"
      subtitle="Outside of intentional workouts — your typical day."
      onBack={onBack}
      isMobile={isMobile}
      primaryLabel="Continue"
      onPrimary={onNext}
    >
      <div style={{ display: "grid", gap: 10 }}>
        {ACTIVITY_OPTIONS.map((opt) => (
          <SelectableCard
            key={opt.key}
            selected={value === opt.key}
            onClick={() => onChange(opt.key, opt.factor)}
            icon={
              <span
                style={{
                  fontWeight: 800,
                  fontSize: "0.78rem",
                  letterSpacing: "-0.01em",
                  ...T.tabular,
                }}
              >
                ×{opt.factor.toFixed(2)}
              </span>
            }
            title={opt.label}
            body={opt.example}
          />
        ))}
      </div>
    </ScreenShell>
  );
}
